<template>
  <div style="position: relative">
    <!-- <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading> -->
    <v-form v-model="valid" v-on:submit="submit" >
      <v-jsf v-model="chosenArena.config.abTestsSettings" :schema="formSchema" />
      <button v-if="$checkRoles(['Administrator'])"
              class="ark-btn ark-btn--default" @click="submit">
        Save ABTests Settings
      </button>
    </v-form>
  </div>
</template>
<script>
import config from '../../../config';

export default {
    components: {},

    props: ['chosenArena', 'formSchema'],

    data() {
        return {
            valid: false,
            isLoading: false,
            formValue: this.chosenArena.config.abTestsSettings
        };
    },
    watch: {
        chosenArena: {
            immediate: true,
            handler(newVal, oldVal) {
                this.isLoading = false;
            }
        }
    },
    methods: {
        submit(e) {
            e.preventDefault();
            // showing loader in btn
            this.isLoading = true;

            const options = {
                params: { domain: this.chosenArena.domain },
                headers: { 'Content-Type': 'application/json-patch+json' }
            };

            this.$http
                .post(
                    `${config.apiUrl}/arena/abtests`,
                    JSON.stringify({
                        ...this.chosenArena.config.abTestsSettings,
                        ver: Math.random().toFixed(5)
                    }),
                    options
                )
                .then(() => {
                    this.isLoading = false;
                })
                .catch((err) => console.error(err.status, err.message));
        }
    }
};
</script>
